import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';


export const useNavigate = route => {
    const { push } = useHistory();
    return useCallback(() => push(route), [push, route]);
};
